import { render, staticRenderFns } from "./DataEvalPercent.vue?vue&type=template&id=64af335f"
import script from "./DataEvalPercent.vue?vue&type=script&lang=js"
export * from "./DataEvalPercent.vue?vue&type=script&lang=js"
import style0 from "./DataEvalPercent.vue?vue&type=style&index=0&id=64af335f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports